import { Link } from 'react-router-dom';
import { useAuthModal } from '../../contexts/AuthModalContext';

export const Footer = () => {
  const { openSignupModal } = useAuthModal();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Creators Archive</h3>
            <p className="text-gray-400">
              Connecting African fashion with global discovery and opportunities.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/archives" className="hover:text-white transition-colors">
                  Explore African Fashion
                </Link>
              </li>
              <li>
                <button onClick={() => openSignupModal()} className="hover:text-white transition-colors">
                  Join Creators Archive
                </button>
              </li>
              <li>
                {/* <Link to="/contact" className="hover:text-white transition-colors">
                  Contact Us
                </Link> */}
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Support: info@ankaragrid.africa</li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} Creators Archive. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/terms" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 